
    const callNodeMailer = (name, email, phone_number, details, SignageTypes, data) => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            name,
            email,
            details,
            "phone": phone_number,
            SignageTypes
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch("https://manhattanneons-nodemailer.vercel.app/send", requestOptions)
            .then((response) => response.text())
            .then((result) => {
                // // console.log('');
                const resultObject = JSON.parse(result);
                if (resultObject.type == 'success') {
                    updateAirTableRow(data);
                } else {
                    // console.log('Error');
                }

            })
            .catch((error) => console.error(error));
    }

    const updateAirTableRow = (data) => {
        // Add the "Sent" field to the data object
        const apiKeySec = 'patXWPtkFycxThMfa.d6570fc1c6241575da65c80d2c1db99e8d9452ee277d4218669a7401e1e37cc4';
        const dataToUpdate = {
                id:data.id,
                fields:{
                  SentStatus: "Email Sent",
                }
          }

        // Fetch request to update the Airtable row
        fetch(`https://api.airtable.com/v0/appoZNzz2eyiP6ilX/Projects`, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${apiKeySec}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                records: [dataToUpdate] // Wrap the data in an array under "records"
            })
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(updatedRecords => {
                console.log('');
            })
            .catch(error => {
                console.error('Error updating records:', error);
            });
    };

